import { Box, Stack, Typography } from '@mui/material';
import React from 'react';
import { LegendProps } from 'recharts';
import styled from 'styled-components';

const StyledLabel = styled(Typography)`
  && {
    font-family: Poppins;
    font-weight: 400;
    font-size: 0.75rem;
    line-height: 16px;
    letter-spacing: 0%;
    text-align: center;
    color: #000000;
  }
`;

export const CustomLegend2: React.FC<LegendProps> = ({ payload }) => {
  if (!payload) return null;

  const labelMap: { [k: string]: string } = {
    gcp_rev: 'GCP Revenue',
    gcp_pipeline: 'GCP Pipeline',
    psfdaf_rev: 'PSF/DAF Services Revenue',
    psfdaf_pipeline: 'PSF/DAF Services Pipeline',
  };

  const colorMap: { [k: string]: string } = {
    gcp_rev: '#4C8EE6',
    gcp_pipeline: '#93C5FD',
    psfdaf_rev: '#E75858',
    psfdaf_pipeline: '#FF9999',
  };

  return (
    <Stack direction="row" gap="32px" ml="30px">
      {Object.keys(labelMap).map((entry) => (
        <Stack
          key={`legend-${entry}`}
          direction="row"
          gap="4px"
          alignItems="center"
        >
          <Box
            sx={{
              width: 12,
              height: 12,
              borderRadius: '4px',
              backgroundColor: colorMap[entry],
            }}
          />
          <StyledLabel>{labelMap[entry]}</StyledLabel>
        </Stack>
      ))}
    </Stack>
  );
};
